import Cookies from "js-cookie";

// Before first page load... set the cookie so GTM can get added before app renders. This is essential for google optimize tests.
const onClientEntry = () => {
    const gdprRegionStatus = Cookies.get("gdprRegion");
    const gdprConsentStatus = Cookies.get("gdprConsent");
    const trackingOffStatus = Cookies.get("trackingOff");

    if (gdprRegionStatus === "false" || (gdprConsentStatus && !trackingOffStatus)) {
        Cookies.set("allow-gtm-ga", true, { expires: 1 });
    } else {
        Cookies.set("allow-gtm-ga", false, { expires: 1 });
    }
};

// Checks cookies on each page change for GDPR and GTM plugin...
const onRouteUpdate = ({ location, prevLocation }) => {
    const gdprRegionStatus = Cookies.get("gdprRegion");
    const gdprConsentStatus = Cookies.get("gdprConsent");
    const trackingOffStatus = Cookies.get("trackingOff");
    const allowGTM = Cookies.get("allow-gtm-ga");

    if (gdprRegionStatus === "false" || (gdprConsentStatus && !trackingOffStatus)) {
        if (!allowGTM) Cookies.set("allow-gtm-ga", true, { expires: 1 });
    } else {
        Cookies.set("allow-gtm-ga", false, { expires: 1 });
    }
};

export { onClientEntry, onRouteUpdate };
